import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";

// ═══════════════════════════════════════════════════════════
// QueryProvider — TanStack Query client setup (TPP §5.1)
// ═══════════════════════════════════════════════════════════

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000, // 30s before data considered stale
      gcTime: 5 * 60_000, // 5min garbage collection
      retry: 2,
      refetchOnWindowFocus: false, // B24 iframe doesn't fire focus events reliably
    },
    mutations: {
      retry: 1,
    },
  },
});

interface QueryProviderProps {
  children: ReactNode;
}

export function QueryProvider({ children }: QueryProviderProps) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
